import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { ApplicationsData } from "./types";
import { applicationsKeys } from "./utils";

/**
 * Fetch a list of applications
 * @param options useQuery options
 * @returns useQuery result
 */
export const useApplications = <TData extends {} = ApplicationsData>(
  options?: UseQueryOptions<ApplicationsData, PortalAxiosError, TData>
) => {
  const server = useServer();

  return useQuery<ApplicationsData, PortalAxiosError, TData>(
    applicationsKeys.list(),
    () => server.get("applications"),
    {
      staleTime: 5 * 60 * 1000,
      ...options,
    }
  );
};

export default useApplications;
